import React from "react";
import * as Sentry from "@sentry/react";

type Props = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

type State = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Sentry に送信（DSN 未設定時は送信されません）
    try {
      Sentry.captureException(error, { extra: { info } });
    } catch (_) {
      void 0; // no-op when Sentry is unavailable
    }
    // eslint-disable-next-line no-console
    console.error("Unhandled error captured by ErrorBoundary", error, info);
  }

  handleReload = () => {
    try {
      window.location.reload();
    } catch (_) {
      void 0; // no-op on reload failure
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div style={{ padding: 24 }}>
            <h2>エラーが発生しました。</h2>
            <p>画面を再読み込みしてやり直してください。</p>
            <button onClick={this.handleReload}>再読み込み</button>
          </div>
        )
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
